/// <reference path="../svg.d.ts" />
import React from 'react';
import {
  User as LucideUser,
  Users as LucideUsers,
  CreditCard,
  Flag,
  Building,
  Contact,
} from 'lucide-react';
import { getIconProps, IconProps } from '../utils';

export const UserIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <LucideUser {...iconProps} />;
};

/**
 * Plural "users" icon — for cards/menus that surface a multi-user
 * concept (team, members, users management). Stays in the
 * `@hero/web-icons` wrapper family so it inherits the standard
 * `strokeWidth: 1.5` and renders at the same visual weight as the
 * other Lucide-wrapped icons.
 */
export const UsersIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <LucideUsers {...iconProps} />;
};

export const IdCardIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <CreditCard {...iconProps} />;
};

export const FlagIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Flag {...iconProps} />;
};

export const BuildingIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Building {...iconProps} />;
};

export const ContactIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Contact {...iconProps} />;
};

export const DriverIcon: React.FC<IconProps> = props => {
  const { className, ...rest } = getIconProps(props);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...rest}>
      <circle cx="12" cy="12" r="10" />
      <path d="m3.3 7 7 4" />
      <path d="m13.7 11 7-4" />
      <path d="M12 14v8" />
      <circle cx="12" cy="12" r="2" />
    </svg>
  );
};
